/**
 * It will find an eamil in the array of contacts we get from api
 * @param {Array} contacts - array of contacts that we get from API
 * @returns {Object} - if we found an email, it returns Object we get from API, otherwise empty object
 */

export default function getEmail(contacts = []) {
	if (!contacts) return {}
	const found = contacts.find(item => item.type === "email")
	if (found) return found
	return {}
}
